"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [{
        label: 'Top',
        value: 'T',
        hint: 'Attempt that ended on a "Top"',
    }, {
        label: '+1',
        value: '1',
        hint: 'Attempt that did not earn credit',
    }];
//# sourceMappingURL=appButtons.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/PointsDecreaseWithAttempts/appButtons.js
// module id = 864
// module chunks = 0